var map = {
	"./basketball.webp": 1687,
	"./bti-img.webp": 1688,
	"./bti-title-cn.webp": 1689,
	"./bti-title-en.webp": 1690,
	"./cup.webp": 1691,
	"./football.webp": 1692,
	"./im-img.webp": 1693,
	"./im-title-cn.webp": 1694,
	"./im-title-en.webp": 1695,
	"./sb-img.webp": 1696,
	"./sb-title-cn.webp": 1697,
	"./sb-title-en.webp": 1698,
	"./sbo-img.webp": 1699,
	"./sbo-title-cn.webp": 1700,
	"./sbo-title-en.webp": 1701,
	"./sport-bg.webp": 1702,
	"./sport-ctg.webp": 1703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;